import React from 'react';
import { connect } from 'react-redux';
import { DisqualificationContext } from './disqualification-context';
import { qualify, disqualify } from '../../redux/actions/disqualification';
import { DisqualificationProps } from './DisqualificationProvider.types';

class DisqualificationProvider extends React.Component<DisqualificationProps, {}> {
  constructor(props: DisqualificationProps) {
    super(props);
  }

  public render(): JSX.Element | null {
    const { children } = this.props;

    return (
      <DisqualificationContext.Provider
        value={{ disqualificationHandler: this.disqualificationHandler }}
      >
        {children}
      </DisqualificationContext.Provider>
    );
  }

  private disqualificationHandler = (field: string, form: any): void => {
    const { qualify, disqualify, disqualifiedFields, disqualificationMessages } = this.props;
    const isDisqualified = disqualifiedFields.includes(field);
    const disqualificationError = form.errors[field] === disqualificationMessages[field];

    if (disqualificationError && !isDisqualified) {
      disqualify({ field });
    }

    if (!disqualificationError && isDisqualified) {
      qualify({ field });
    }
  };
}

const mapStateToProps = (state: any) => ({
  disqualifiedFields: state.disqualification.disqualifiedFields
});

export default connect(
  mapStateToProps,
  {
    qualify,
    disqualify
  }
)(DisqualificationProvider);
